import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { NgpLabelValue } from '../../../form/NgpLabelValue';
import {
    BOOT_TIME_FIELD,
    HOSTNAME_FIELD,
    IPADDRESS_FIELD,
    IPADDRESSES_FIELD,
    LABEL_DATA_CENTER,
    LABEL_HOSTNAME,
    LABEL_HYPERVISOR,
    LABEL_IP_ADDRESS,
    LABEL_IP_ADDRESSES,
    LABEL_NAME,
    LABEL_POWER_STATE,
    LABEL_RESOURCEPOOL,
    LABEL_SITES,
    LABEL_TECHNOLOGY,
    LABEL_UP_TIME,
    LABEL_VCENTER,
    LABEL_VENDOR,
    LABEL_VIRTUAL_TYPE,
    MAPPING_DATACENTER_FIELD,
    NAME_FIELD,
    POWERSTATE_FIELD,
    RESOURCEPOOL_FIELD,
    SUBTYPE_FIELD,
    TECHNOLOGY_FIELD,
    VENDOR_FIELD,
} from '../InfrastructureConstants';
import { powerStateFormatter, serverSubTypeFormatter } from '../InfrastructureFormatters';
import { getUpTimeDuration } from '../../../../utilities/DateTimeUtilities';
import VcenterLink from './VcenterLink';
import HypervisorLink from './HypervisorLink';
import SitesLink from '../SitesLink';
import PropertiesGrid, { PropertiesGridFullWidth } from '../../../form/PropertiesGrid';
import { EMPTY_IP_VALUE, getFieldValue, safeFormat, usePropertyValues } from '../InfrastructurePropertiesUtils';
import PropertiesIpAddressList from '../../../properties/PropertiesIpAddressList';

/**
 * Displays virtual machine properties in label-value pairs
 * Shows VM details, power state, and related infrastructure links
 */
const VirtualMachineProperties = () => {
    const extractPropertyValues = useCallback(
        (formData) => ({
            name: getFieldValue(formData, NAME_FIELD),
            hostname: getFieldValue(formData, HOSTNAME_FIELD),
            ipAddress: getFieldValue(formData, IPADDRESS_FIELD),
            ipAddresses: getFieldValue(formData, IPADDRESSES_FIELD),
            virtualType: safeFormat(serverSubTypeFormatter, getFieldValue(formData, SUBTYPE_FIELD)),
            powerState: safeFormat(powerStateFormatter, getFieldValue(formData, POWERSTATE_FIELD)),
            upTime: safeFormat(getUpTimeDuration, getFieldValue(formData, BOOT_TIME_FIELD)),
            vendor: getFieldValue(formData, VENDOR_FIELD),
            technology: getFieldValue(formData, TECHNOLOGY_FIELD),
            dataCenter: getFieldValue(formData, MAPPING_DATACENTER_FIELD),
            resourcePool: getFieldValue(formData, RESOURCEPOOL_FIELD),
        }),
        []
    );

    const props = usePropertyValues(extractPropertyValues);

    return (
        <PropertiesGrid>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_NAME} dataValue={props.name} />
            </PropertiesGridFullWidth>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_HOSTNAME} dataValue={props.hostname} />
            </PropertiesGridFullWidth>
            <NgpLabelValue dataLabel={LABEL_IP_ADDRESS} dataValue={props.ipAddress} />
            <NgpLabelValue dataLabel={LABEL_VIRTUAL_TYPE} dataValue={props.virtualType} />
            <NgpLabelValue dataLabel={LABEL_POWER_STATE} dataValue={props.powerState} />
            <NgpLabelValue dataLabel={LABEL_UP_TIME} dataValue={props.upTime} />
            <NgpLabelValue dataLabel={LABEL_VENDOR} dataValue={props.vendor} />
            <NgpLabelValue dataLabel={LABEL_TECHNOLOGY} dataValue={props.technology} />
            <NgpLabelValue dataLabel={LABEL_VCENTER} dataValue={<VcenterLink />} />
            <NgpLabelValue dataLabel={LABEL_DATA_CENTER} dataValue={props.dataCenter} />
            <NgpLabelValue dataLabel={LABEL_RESOURCEPOOL} dataValue={props.resourcePool} />
            <NgpLabelValue dataLabel={LABEL_HYPERVISOR} dataValue={<HypervisorLink />} />
            <NgpLabelValue dataLabel={LABEL_SITES} dataValue={<SitesLink />} />
            <NgpLabelValue
                dataLabel={LABEL_IP_ADDRESSES}
                dataValue={
                    isEmpty(props.ipAddresses) ? EMPTY_IP_VALUE : <PropertiesIpAddressList value={props.ipAddresses} />
                }
            />
        </PropertiesGrid>
    );
};

export default VirtualMachineProperties;
